module.exports = __webpack_public_path__ + "6ed619af12b23e3e6fb53144d761a959.pdf";